/**
 * Confirmation Message Page
 * @author PBirudukota
 */
import {Component, OnInit} from '@angular/core';
import {MessagesService} from '../../services/messages.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  enableActions: boolean = false;
  header: string;
  subHeader: string;
  title: string;
  currentYear: string = new Date().getFullYear().toString();

  constructor(private messagesService: MessagesService, private route: ActivatedRoute) {
    this.messagesService.sendBGMessage('yes');
    this.header = `Your Application Number is #${this.route.snapshot.params['applicationId']}`;
    this.subHeader = `Please save this Application Number for future reference. You will receive an email from DocuSign to sign the Application.`;
    this.title = `Thank You for Partnering with ATD`;
    this.messagesService.sendLogoMessage('atd');
  }

  ngOnInit() {
  }

}
